export default __webpack_public_path__ + "5da5f785361da0002b21da8f1db1a3c8.png";